<div>
  <app-agb></app-agb>
</div>
